import React from "react";
import TextAreaCustom from "../../components/elements/TextAreaCustom";
import { AbstructVar } from "../../components/general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../components/general/general-component/abstruct-component/AbstructLang";
import SelectDropDown from "../../components/elements/SelectDropDown";
import InputCustom from "../../components/elements/InputCustom";

function AddProductionCrewScriptArchive({ page_list_scripts_archive,fields, setFields }) {
  const { dispatch, langLocal, navigate } = AbstructVar();
  const { translate } = AbstructLang();
  const handleFieldChange = (index, field, value) => {
    const newFields = [...fields];
    newFields[index][field] = value;
    setFields(newFields);
  };

  const addField = () => {
    const newFields = [...fields, { name: "", description: "" ,production_crew_id:""}];
    setFields(newFields);
  };

  const removeField = (index) => {
    const newFields = [...fields];
    newFields.splice(index, 1);
    setFields(newFields);
  };
  return (
    <>
      {fields.map((field, index) => (
        <div key={index}>
          <div className="d-flex">

            <InputCustom
              label='name'
              iconType='pencil'
              type='text'
              onChange={(e) =>
                handleFieldChange(index, "name", e.target.value)
              }
            />
            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`}>
              <span>{translate('type')}</span>
              <SelectDropDown
                options={page_list_scripts_archive?.production_crews?.map((crew)=>({
                  label: crew?.name,value: crew?.id
                }))}
                varr={fields[index].production_crew_id}
                setVarr={(e) => handleFieldChange(index, "production_crew_id", e)}
              />
            </div>

            <div className="one-text-area" style={{ width: "48%" }}>
              <TextAreaCustom
                label="description"
                onChange={(e) =>
                  handleFieldChange(index, "description", e.target.value)
                }
                nameClass="textarea-gen"
              />
            </div>

            {index === 0 && (
              <i className="fa fa-plus plus-arr" onClick={addField}></i>
            )}
            {index > 0 && (
              <i
                className="fa fa-minus minus-arr"
                onClick={() => removeField(index)}
              ></i>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default AddProductionCrewScriptArchive;
